import DocumentCreationButton from 'Components/DocumentCreationButton';
import { Item } from 'Components/Grid';
import HistoryRowControls from 'Components/HistoryRowControls';
import HistoryRowListing from 'Components/HistoryRowListing';
import HistorySection from 'Components/HistorySection';
import { cdr } from 'neuro-schemas';
import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import DescriptionText from 'Routes/Cognition/utils/DescriptionText';
import { formatPartialDate } from 'Utility/date';

const {
  utils: { getCDRClass, getFTLDCDRClass, calculateCDRScore, calculateFTLDCDRScore },
} = cdr;

const CDR = ({ documents, startEdit, view }: IOwnProps): React.JSX.Element => {
  return (
    <HistorySection
      headerText={<FormattedMessage id="cognition.cdr.cdrLong" />}
      newButton={
        <DocumentCreationButton
          name="cdr"
          text="cognition.cdr.newCdr"
          onClick={startEdit({}, 'cdr')}
          width={15}
          height={3}
          fontSize={14}
          alternate={true}
        />
      }
      headerInfoText={<DescriptionText type={'cdr'} />}
    >
      <HistoryRowListing
        documents={documents}
        headers={
          <>
            <Item xs={2}>
              <FormattedMessage id="general.date" />
            </Item>
            <Item xs={2}>
              <FormattedMessage id="cognition.cdr.cdrClass" /> (0-3)
            </Item>
            <Item xs={2}>
              <FormattedMessage id="cognition.cdr.cdrTotalScore" /> (0-18)
            </Item>
            <Item xs={2}>
              <FormattedMessage id="cognition.cdr.ftldCdrClass" /> (0-3)
            </Item>
            <Item xs={1}>
              <FormattedMessage id="cognition.cdr.ftldCdrTotalScore" /> (0-24)
            </Item>
            <Item xs={3} />
          </>
        }
        contentFormat={d => (
          <>
            <Item xs={2}>{d.date ? formatPartialDate(d.date) : '-'}</Item>
            <Item xs={2}>{getCDRClass(d) ?? '-'}</Item>
            <Item xs={2}>{calculateCDRScore(d) ?? '-'}</Item>
            <Item xs={2}>{getFTLDCDRClass(d) ?? '-'}</Item>
            <Item xs={1}>{calculateFTLDCDRScore(d) ?? '-'}</Item>
            <Item xs={3}>
              <HistoryRowControls document={d} startEdit={startEdit} view={view} />
            </Item>
          </>
        )}
      />
    </HistorySection>
  );
};

interface IOwnProps {
  documents: IDocumentWithTypeV2<'cdr'>[];
  startEdit: StartEdit;
  view?: IView;
}

export default CDR;
